import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { leagueIds, ratePlanCodes, sportIds, networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'MLB Network',
    callsign: 'MLBHD',
    logoUrl: networkLogos.mlbnetwork.logoUrl,
    slug: 'mlb-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="MLBHD"
        title="Watch MLB Network live with Fubo"
        customNetworks={['mlbtv', 'mlbnetwork']}
        networkName="MLB Network"
        highlightImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/mlb-tv-phone.png?ch=width&auto=format,compress"
        highlightHeadline="Get MLB.TV with Fubo"
        highlightSubtitle="See every out-of-market MLB team in action in over 2,000 live games this season. Watch them all live from your TV, phone & other devices."
        highlightUrlParams={[{ offer: ratePlanCodes.mlbtv_mo }]}
        caRedirectUrl="/live/preview/ca/mlb-tv/"
        sportId={sportIds.Baseball}
        leagueId={leagueIds.MLB}
      />
    </>
  )
}
